import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Check } from "lucide-react";
import { toast } from "sonner";
import { useCjCart } from "../../context/CjCartContext";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const MarketCard = ({ product }) => {
  const [err, setErr] = useState(false);
  const [added, setAdded] = useState(false);
  const { add } = useCjCart();
  if (!product) return null;
  const to = `/market/product/${product.handle}`;
  const onSale = product.original_price && product.original_price > product.price;

  const quickAdd = (e) => {
    e.preventDefault();
    add(product, 1);
    setAdded(true);
    toast.success("Added to cart");
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <div className="group" data-testid={`market-card-${product.handle}`}>
      <Link to={to} className="block aspect-[4/5] bg-white rounded-lg overflow-hidden relative border border-black/5">
        {product.image && !err ? (
          <img src={product.image} alt={product.title} loading="lazy" onError={() => setErr(true)}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-taven-gray text-muted-foreground text-xs font-display font-bold tracking-widest">TAVEN</div>
        )}
        {onSale && (
          <span className="absolute top-2 left-2 bg-taven-orange text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-testid="market-discount-badge">
            -{product.discount_percent}%
          </span>
        )}
        <button onClick={quickAdd} data-testid={`market-add-${product.handle}`}
          className="absolute bottom-2 right-2 h-9 w-9 rounded-full bg-black text-white flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity hover:bg-taven-gold hover:text-black">
          {added ? <Check className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
        </button>
      </Link>
      <Link to={to} className="block mt-2">
        <p className="text-xs sm:text-sm font-medium line-clamp-2 leading-snug hover:text-taven-gold">{product.title}</p>
        <div className="flex items-baseline gap-2 mt-1">
          <span className="text-sm font-black">{money(product.price)}</span>
          {onSale && <span className="text-xs text-muted-foreground line-through">{money(product.original_price)}</span>}
        </div>
      </Link>
    </div>
  );
};

export default MarketCard;
